export default "__VITE_ASSET__BbI3KLT9__"